var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g, _g2, _g3, _g4, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464.497 130.564C462.913 127.877 461.251 125.241 459.51 122.661C436.327 88.3149 396.439 64.8229 357.198 54.2029C340.014 49.5519 322.268 47.1139 304.487 46.5109C187.873 42.5579 141.425 134.466 102.883 158.184C64.341 181.902 5.045 222.421 8.998 307.411C12.951 392.401 74.223 472.45 192.814 477.391C311.405 482.332 319.311 428.967 385.524 409.201C429.343 396.121 460.476 351.941 475.721 311.113C496.496 255.471 495.517 183.197 464.497 130.564Z",
    fill: "#3AF2AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M464.497 130.564C462.913 127.877 461.251 125.241 459.51 122.661C436.327 88.3149 396.439 64.8229 357.198 54.2029C340.014 49.5519 322.268 47.1139 304.487 46.5109C187.873 42.5579 141.425 134.466 102.883 158.184C64.341 181.902 5.045 222.421 8.998 307.411C12.951 392.401 74.223 472.45 192.814 477.391C311.405 482.332 319.311 428.967 385.524 409.201C429.343 396.121 460.476 351.941 475.721 311.113C496.496 255.471 495.517 183.197 464.497 130.564Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M462 300.05H420V317.05H462V300.05Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M325.375 162.797H283.375V179.797H325.375V162.797Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M299.512 188.485H257.512V205.485H299.512V188.485Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M327.964 75.641H285.964V92.641H327.964V75.641Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M294 281.807H252V298.807H294V281.807Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.203 130.006H169.203V147.006H211.203V130.006Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M257.203 130.006H215.203V147.006H257.203V130.006Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M222 407.517H180V424.517H222V407.517Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M200 428.517H158V445.517H200V428.517Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M276.512 211.985H234.512V228.985H276.512V211.985Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M214.381 87.722H172.381V104.722H214.381V87.722Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M486 340.807H444V357.807H486V340.807Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M240 366.807H198V383.807H240V366.807Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M288 366.807H246V383.807H288V366.807Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M292 342.807H250V359.807H292V342.807Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M324.512 211.985H282.512V228.985H324.512V211.985Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M346 426.807H304V443.807H346V426.807Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M323 450.307H281V467.307H323V450.307Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M371 450.307H329V467.307H371V450.307Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.392 215.218H100.392V232.218H142.392V215.218Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M119.392 238.718H77.3921V255.718H119.392V238.718Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M167.392 238.718H125.392V255.718H167.392V238.718Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M126 341.807H84V358.807H126V341.807Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M312 260.517H270V277.517H312V260.517Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M249 427.517H207V444.517H249V427.517Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M235.203 109.006H193.203V126.006H235.203V109.006Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M102 285.517H60V302.517H102V285.517Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M126 264.517H84V281.517H126V264.517Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M233 162.307H191V179.307H233V162.307Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M171.772 172.29H129.772V189.29H171.772V172.29Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M379 300.05H337V317.05H379V300.05Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.5352 394.078H30.5352V411.078H72.5352V394.078Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.3921 155.218H12.3921V172.218H54.3921V155.218Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M102.392 155.218H60.3921V172.218H102.392V155.218Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M106.392 131.218H64.3921V148.218H106.392V131.218Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M75 199.518H33V216.518H75V199.518Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.535 411.578H87.5352V428.578H129.535V411.578Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.297 25.495V265.329H478.264V25.495H327.297ZM472.768 83.11H406.224V34.226H472.768V83.11ZM406.224 148.258H472.768V200.633H406.224V148.258ZM406.224 141.872V89.496H472.768V141.871L406.224 141.872ZM332.793 34.226H399.337V83.11H333.132V89.496H399.337V141.871H333.132V148.257H399.337V200.632H333.132V207.018H399.337V256.597H332.793V34.226ZM406.224 256.598V207.019H472.768V256.598H406.224Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.8 48.843L356.227 76.627",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.366 103.254L422.794 131.038",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.538 220.758L346.966 248.542",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.194 56.947L356.806 69.681",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.81 96.886L438.422 109.621",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.561 229.441L363.173 242.175",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.93 168.084L358.543 180.818",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.652 221.916L437.265 234.65",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.624 265.17H318.603V286.167H487.624V265.17Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.837 117.782L79.461 111.739H39.427L40.051 117.782H78.837Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1959 133.671H41.6919L37.2539 90.697H81.6339L77.1959 133.671Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.505 90.3891C44.505 90.3891 38.865 89.5831 33.629 85.1521C28.392 80.7211 19.127 79.5121 15.905 81.9291C12.682 84.3461 9.45996 87.5691 9.45996 87.5691C9.45996 87.5691 11.877 78.7071 18.322 76.6931C24.767 74.6791 28.796 76.6931 32.421 78.3041C36.046 79.9151 37.658 81.1241 41.686 83.5411C45.714 85.9581 48.131 87.9721 48.131 87.9721C48.131 87.9721 46.923 82.7351 44.506 80.3181C42.089 77.9011 27.587 67.4281 27.587 67.4281C27.587 67.4281 35.644 69.4421 40.88 71.8591C46.117 74.2761 50.145 78.7071 50.548 80.7211C50.951 82.7351 52.562 86.3611 52.562 86.3611L54.173 90.3891C54.173 90.3891 53.77 84.3471 53.367 79.9161C52.964 75.4851 52.159 72.6651 52.561 68.2341C52.964 63.8031 53.769 60.9831 53.769 58.5661C53.769 56.1491 54.977 53.7321 54.977 53.7321C54.977 53.7321 56.588 65.0111 57.394 68.6371C58.2 72.2621 58.2 77.0961 58.602 79.5131C59.005 81.9301 60.213 89.1811 60.213 89.1811C60.213 89.1811 59.407 83.1391 61.824 79.9161C64.241 76.6931 65.047 74.2761 66.658 71.8591C68.269 69.4421 70.283 65.4141 70.283 65.4141C70.283 65.4141 70.283 71.8591 68.672 75.8881C67.061 79.9161 65.852 81.9301 65.852 83.5421C65.852 85.1531 65.852 89.1821 65.852 89.1821C65.852 89.1821 69.88 81.9311 72.297 79.9171C74.714 77.9031 76.325 77.9031 77.131 76.6941C77.937 75.4861 82.771 72.6661 82.771 72.6661C82.771 72.6661 79.951 79.1111 79.146 80.3201C78.34 81.5281 74.312 85.1541 74.312 85.1541C74.312 85.1541 79.146 82.7371 83.174 81.5281C87.202 80.3201 93.245 79.1111 95.662 79.1111C98.079 79.1111 106.135 77.9031 106.135 77.9031C106.135 77.9031 98.884 81.1261 94.453 82.7371C90.022 84.3481 87.202 85.1541 85.591 85.5571C83.98 85.9601 83.98 85.9601 83.98 85.9601C83.98 85.9601 89.62 86.7661 95.259 88.7801C100.899 90.7941 102.51 92.4061 103.315 93.6141C104.121 94.8221 104.524 96.8371 104.524 96.8371C104.524 96.8371 106.941 98.8511 106.941 100.462C106.941 102.073 96.065 92.8081 92.036 91.6001C88.008 90.3911 81.632 90.6991 81.632 90.6991",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.043 148.201L103.62 144.107H130.746L130.323 148.201H104.043Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.155 158.967H129.211L132.218 129.849H102.148L105.155 158.967Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.305 129.641C127.305 129.641 131.126 129.095 134.674 126.093C138.222 123.091 144.5 122.272 146.683 123.909C148.867 125.547 151.05 127.73 151.05 127.73C151.05 127.73 149.412 121.725 145.045 120.361C140.678 118.996 137.949 120.361 135.492 121.453C133.036 122.545 131.944 123.364 129.214 125.001C126.485 126.639 124.847 128.003 124.847 128.003C124.847 128.003 125.666 124.455 127.303 122.817C128.941 121.179 138.767 114.083 138.767 114.083C138.767 114.083 133.308 115.448 129.76 117.085C126.212 118.723 123.482 121.725 123.209 123.09C122.936 124.455 121.844 126.911 121.844 126.911L120.752 129.64C120.752 129.64 121.025 125.546 121.298 122.543C121.571 119.541 122.117 117.63 121.844 114.628C121.571 111.626 121.025 109.715 121.025 108.078C121.025 106.44 120.206 104.803 120.206 104.803C120.206 104.803 119.114 112.445 118.568 114.902C118.022 117.359 118.022 120.634 117.749 122.271C117.476 123.909 116.657 128.822 116.657 128.822C116.657 128.822 117.203 124.728 115.565 122.544C113.927 120.36 113.381 118.723 112.29 117.085C111.198 115.447 109.834 112.718 109.834 112.718C109.834 112.718 109.834 117.085 110.926 119.814C112.018 122.543 112.837 123.908 112.837 125C112.837 126.092 112.837 128.821 112.837 128.821C112.837 128.821 110.108 123.908 108.47 122.543C106.832 121.178 105.741 121.178 105.195 120.359C104.649 119.54 101.374 117.63 101.374 117.63C101.374 117.63 103.285 121.997 103.83 122.816C104.376 123.635 107.105 126.091 107.105 126.091C107.105 126.091 103.83 124.453 101.1 123.634C98.371 122.815 94.277 121.996 92.639 121.996C91.001 121.996 85.543 121.177 85.543 121.177C85.543 121.177 90.456 123.361 93.458 124.452C96.46 125.544 98.371 126.09 99.463 126.363C100.555 126.636 100.555 126.636 100.555 126.636C100.555 126.636 96.734 127.182 92.913 128.546C89.092 129.911 88 131.003 87.454 131.821C86.908 132.64 86.635 134.005 86.635 134.005C86.635 134.005 85 135.373 85 136.465C85 137.557 92.369 131.279 95.099 130.46C97.828 129.641 102.148 129.849 102.148 129.849",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.266 79.307L156.751 74.61H125.635L126.12 79.307H156.266Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.991 91.657H127.396L123.946 58.255H158.44L154.991 91.657Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.946 58.2551C123.946 58.2551 120.111 54.4881 117.875 53.5301C115.639 52.5721 111.487 50.9751 111.487 50.9751C111.487 50.9751 116.598 50.9751 120.111 52.5721C123.625 54.1691 127.138 56.4051 127.138 56.4051C127.138 56.4051 123.944 51.9331 121.389 48.7391C118.834 45.5451 113.084 40.1151 112.765 38.5181C112.446 36.9211 120.431 43.9481 125.861 48.1001C131.291 52.2521 132.249 55.1271 132.249 55.1271C132.249 55.1271 128.097 47.4611 124.903 40.7541C121.709 34.0461 118.834 30.2131 117.876 28.9361C116.918 27.6581 127.139 39.4771 130.652 45.2261C134.166 50.9751 136.401 54.4891 136.401 54.4891C136.401 54.4891 132.568 35.3241 131.929 30.8531C131.29 26.3811 130.651 21.9091 130.651 21.9091C130.651 21.9091 136.72 39.4771 137.678 42.6711C138.636 45.8651 140.233 51.6141 140.233 51.6141C140.233 51.6141 142.15 42.3511 142.788 36.6021C143.426 30.8531 146.302 22.5481 146.302 22.5481C146.302 22.5481 145.024 40.4351 144.705 44.9071C144.386 49.3791 144.066 53.8501 144.066 53.8501C144.066 53.8501 147.26 45.5451 150.135 41.7121C153.01 37.8791 158.12 32.7691 158.12 32.7691C158.12 32.7691 152.69 42.9901 151.412 46.1841C150.134 49.3781 148.537 55.1271 148.537 55.1271C148.537 55.1271 154.925 45.2251 157.8 42.0311C160.675 38.8371 163.549 37.2401 166.105 35.6431C168.66 34.0461 158.12 46.8221 156.842 49.6971C155.564 52.5721 153.967 55.1271 153.967 55.1271C153.967 55.1271 155.883 52.5721 160.994 50.6551C166.104 48.7381 175.048 46.8221 176.326 46.8221C177.604 46.8221 168.341 50.6551 165.147 51.9321C161.953 53.2101 158.439 58.2541 158.439 58.2541",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M386.479 178.606C390.121 163.82 377.275 147.942 357.785 143.14C338.296 138.339 319.543 146.434 315.901 161.22C312.258 176.006 325.105 191.884 344.595 196.685C364.084 201.486 382.837 193.392 386.479 178.606Z",
    fill: "#32DCDC",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M330.643 181.856C330.643 181.856 323.429 183.823 320.15 179.889C316.871 175.954 321.79 164.477 327.2 159.231C332.61 153.984 347.858 151.689 355.728 152.509C363.598 153.329 372.943 159.231 374.255 165.461C375.567 171.691 372.943 177.758 372.779 179.725C372.615 181.692 368.024 181.692 367.369 180.709C366.713 179.725 356.876 165.297 354.908 164.641C352.941 163.985 351.629 165.297 349.498 166.445C347.367 167.593 331.135 174.479 331.135 174.479L330.643 181.856Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M354.521 346.408L351.283 325.36L343.835 350.941L343.836 350.943C342.036 354.02 339.906 357.994 338.932 361.08C337.085 366.935 346.406 385.404 347.022 383.452C347.638 381.5 351.148 356.447 351.148 356.447C351.148 356.447 351.799 352.145 351.514 348.77L354.521 346.408Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M350.201 361.305C350.201 361.305 343.461 363.6 343.461 377.91C343.461 381.812 349.022 422.801 349.022 429.657C349.022 442.585 349.022 458.098 349.022 458.098H386.258L390.855 431.093L394.302 457.523H431.649C431.649 457.523 435.384 415.867 435.671 410.696C435.958 405.525 438.544 394.321 437.682 378.807C436.82 363.294 433.373 357.261 433.373 357.261L351.034 355.825L350.201 361.305Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M357.109 217.157C357.109 217.157 339.559 232.109 335.756 236.206C331.812 240.454 333.454 263.867 338.495 280C343.536 296.133 348.885 321.075 349.137 326.117C349.389 331.158 350.201 361.305 350.201 361.305C350.201 361.305 381.518 373.657 400.676 370.632C419.834 367.607 433.446 359.541 433.446 359.541C433.446 359.541 430.421 307.865 430.421 296.522C430.421 285.179 427.9 247.619 425.379 234.511C422.858 221.403 414.036 213.589 407.482 212.832C400.928 212.076 376.412 210.976 376.412 210.976L357.109 217.157Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M348.245 213.616C348.245 213.616 356.167 235.841 357.487 236.061C358.807 236.281 362.328 232.76 362.328 232.76L376.411 210.975L370.811 190.874C370.811 190.874 367.609 201.513 361.447 208.335C355.287 215.156 348.245 213.616 348.245 213.616Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M363.55 209.273L353.164 225.354L348.245 213.616L363.55 209.273Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M354.417 158.574C354.417 158.574 345.399 165.788 338.185 168.411C330.971 171.034 327.364 172.018 327.364 172.018C327.364 172.018 329.659 186.61 330.315 190.709C330.971 194.808 332.446 201.694 335.398 204.645C338.349 207.596 345.563 214.646 348.842 216.45C352.121 218.253 357.695 216.778 359.335 215.958C360.974 215.138 370.484 200.71 370.976 198.743C371.468 196.776 370.812 190.873 370.812 190.873C370.812 190.873 375.075 188.578 375.731 186.282C376.387 183.987 374.911 175.461 373.6 174.313C372.288 173.165 370.157 174.477 369.829 175.789C369.501 177.101 368.517 179.068 368.517 179.068C368.517 179.068 368.353 175.625 367.041 173.494C365.729 171.363 365.729 170.543 362.614 168.083C359.499 165.625 354.417 158.574 354.417 158.574Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M343.432 190.874L343.924 195.301C343.924 195.301 349.335 195.137 351.794 192.514",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M340.972 199.891C340.972 199.891 344.907 201.203 350.973 199.399C357.039 197.596 358.515 193.333 358.515 193.333",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M339.825 179.889C339.825 179.889 332.775 177.594 330.644 181.856",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M347.039 177.265C347.039 177.265 351.794 172.51 356.712 174.314",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M339.094 186.189C339.56 187.465 339.421 188.688 338.783 188.921C338.145 189.154 337.25 188.309 336.784 187.033C336.318 185.757 336.457 184.534 337.095 184.301C337.733 184.068 338.628 184.913 339.094 186.189Z",
    fill: "#263238"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M354.349 181.504C354.815 182.78 354.676 184.003 354.038 184.236C353.4 184.469 352.505 183.624 352.039 182.348C351.573 181.072 351.712 179.849 352.35 179.616C352.988 179.383 353.883 180.228 354.349 181.504Z",
    fill: "#263238"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M391.601 240.559L405.969 291.983C405.969 291.983 405.213 294.504 405.717 296.016C406.221 297.528 406.473 298.789 406.473 298.789C406.473 298.789 402.44 318.955 398.911 331.307C395.382 343.659 382.778 370.631 383.282 373.656C383.786 376.681 380.761 399.368 382.274 400.376C383.786 401.384 387.316 402.897 388.324 402.897C389.332 402.897 393.87 403.401 395.382 403.401C396.895 403.401 402.44 403.149 403.448 401.132C404.456 399.115 404.204 397.855 402.692 398.359C401.179 398.863 398.659 399.115 398.659 399.115L397.651 397.098C397.651 397.098 398.911 388.275 397.651 381.721C396.391 375.167 395.887 372.898 395.887 372.898C395.887 372.898 427.397 321.726 428.657 312.147C429.917 302.568 431.934 291.981 431.934 287.191C431.934 282.402 426.892 239.296 425.38 234.507C423.868 229.718 423.111 224.928 419.078 220.895C415.045 216.862 412.272 216.862 410.255 216.862",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M391.601 240.559L405.969 291.983C405.969 291.983 405.213 294.504 405.717 296.016C406.221 297.528 406.473 298.789 406.473 298.789C406.473 298.789 402.44 318.955 398.911 331.307C395.382 343.659 382.778 370.631 383.282 373.656C383.786 376.681 380.761 399.368 382.274 400.376C383.786 401.384 387.316 402.897 388.324 402.897C389.332 402.897 393.87 403.401 395.382 403.401C396.895 403.401 402.44 403.149 403.448 401.132C404.456 399.115 404.204 397.855 402.692 398.359C401.179 398.863 398.659 399.115 398.659 399.115L397.651 397.098C397.651 397.098 398.911 388.275 397.651 381.721C396.391 375.167 395.887 372.898 395.887 372.898C395.887 372.898 427.397 321.726 428.657 312.147C429.917 302.568 431.934 291.981 431.934 287.191C431.934 282.402 426.892 239.296 425.38 234.507C423.868 229.718 423.111 224.928 419.078 220.895C415.045 216.862 412.272 216.862 410.255 216.862",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M408.498 297.414C408.498 297.414 415.9 294.33 422.223 297.105",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M413.279 291.862C413.279 291.862 421.761 289.857 427.158 296.18",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M401.293 322.205C400.507 325.42 399.697 328.558 398.911 331.307C395.382 343.659 382.778 370.631 383.282 373.656C383.786 376.681 380.761 399.368 382.274 400.376C383.787 401.384 387.316 402.897 388.324 402.897C389.332 402.897 393.87 403.401 395.382 403.401C396.895 403.401 402.44 403.149 403.448 401.132C404.456 399.115 404.204 397.855 402.692 398.359C401.179 398.863 398.659 399.115 398.659 399.115L397.651 397.098C397.651 397.098 398.911 388.275 397.651 381.721C396.391 375.167 395.887 372.898 395.887 372.898C395.887 372.898 411.026 348.311 420.737 330.032C414.458 323.5 406.54 322.207 401.293 322.205Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M392.511 398.732C392.511 398.732 395.01 400.847 395.876 401.52C396.741 402.193 397.03 402.866 398.664 403.058",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M392.511 398.732C392.511 398.732 395.01 400.847 395.876 401.52C396.741 402.193 397.03 402.866 398.664 403.058",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M387.609 399.982C387.609 399.982 391.358 402.77 393.665 403.347L387.609 399.982Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M387.609 399.982C387.609 399.982 391.358 402.77 393.665 403.347",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M383.475 399.405C383.475 399.405 385.205 401.712 387.128 402.577L383.475 399.405Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M383.475 399.405C383.475 399.405 385.205 401.712 387.128 402.577",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M350.103 355.089C350.103 355.089 351.018 361.858 351.384 362.956C351.75 364.054 351.201 366.066 351.567 370.274C351.933 374.482 353.031 378.873 350.286 378.141C347.542 377.409 346.261 370.274 346.444 368.444C346.627 366.614 343.334 361.126 343.334 361.126",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M350.103 355.089C350.103 355.089 351.018 361.858 351.384 362.956C351.75 364.054 351.201 366.066 351.567 370.274C351.933 374.482 353.031 378.873 350.286 378.141C347.542 377.409 346.261 370.274 346.444 368.444C346.627 366.614 343.334 361.126 343.334 361.126",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M296.82 317.971C294.264 313.067 275.247 245.68 275.247 245.68C271.666 255.487 269.378 303.855 269.378 303.855L271.459 329.507L271.086 334.315C276.054 330.913 288.225 324.187 296.315 333.142C296.443 332.671 296.536 332.272 296.586 331.959C297.635 325.495 299.376 322.874 296.82 317.971Z",
    fill: "#40B0D5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M290.69 324.458C291.981 324.681 293.234 325.032 294.407 325.549",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M272.861 326.833C272.861 326.833 279.255 324.327 286.041 324.153",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M293.162 321.76C293.162 321.76 287.555 318.363 283.065 319.7",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M179.614 457.429L180.797 406.05L184.449 377.857L269.436 374.958L277.015 395.169L281.684 458.098H238.665L230.538 416.417L228.211 420.429L227.319 457.206L179.614 457.429Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M206.383 236.096C206.383 236.096 169.367 245.903 167.112 247.018C164.856 248.132 169.835 281.789 173.326 294.049C176.818 306.308 185.31 351.333 185.31 351.333L184.743 383.876C184.743 383.876 221.053 384.768 235.585 382.984C250.116 381.201 266.039 377.189 266.039 377.189C266.039 377.189 271.194 348.436 269.425 329.49C267.656 310.544 272.809 263.513 272.885 260.393C272.961 257.272 275.248 245.682 275.248 245.682C275.248 245.682 247.592 237.212 240.481 236.321C233.369 235.427 216.663 234.981 206.383 236.096Z",
    fill: "#40B0D5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M199.41 244.401C199.41 244.401 204.022 257.111 214.908 264.696",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M237.595 242.146C237.595 242.146 235.631 247.066 232.426 252.396",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M231.746 255.061L229.837 257.726",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M218.418 380.246C227.023 379.738 242.793 378.357 253.032 374.783",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M212.302 380.522C212.302 380.522 213.281 380.499 214.965 380.424",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M247.725 370.969C236.432 372.439 219.315 373.77 205.976 370.888",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M259.731 369.042C259.731 369.042 256.879 369.628 252.296 370.324",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M258.794 353.374C251.96 357.328 238.912 364.048 225.975 366.172",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M263.669 350.387C263.669 350.387 262.746 351.006 261.107 352.003",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M201.145 223.289L202.699 241.185C202.699 241.185 208.173 254.151 220.897 253.314C233.375 252.494 235.221 236.612 235.221 236.612L232.697 217.722C232.697 217.722 221.738 226.868 215.593 226.073C209.448 225.277 201.145 223.289 201.145 223.289Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M188.466 202.096C188.466 202.096 186.197 199.206 184.482 201.821C182.767 204.436 184.799 211.454 187.927 212.967C191.055 214.481 191.881 214.481 191.881 214.481C191.881 214.481 195.426 221.499 197.303 223.563C199.179 225.627 212.841 235.397 216.13 235.948C219.419 236.499 224.121 235.535 225.957 233.609C227.793 231.683 233.618 218.472 234.52 215.307C235.422 212.142 235.577 211.454 235.624 209.528C235.671 207.601 235.573 205.95 235.573 205.95C235.573 205.95 238.855 201.134 239.223 197.281C239.592 193.428 238.699 190.538 236.648 189.988C234.597 189.438 232.295 193.566 232.295 193.566L225.378 172.374C225.378 172.374 223.041 166.594 220.994 165.906C218.946 165.218 204.179 167.007 197.923 169.621C191.667 172.236 185.546 174.988 185.063 177.878C184.58 180.767 188.466 202.096 188.466 202.096Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M199.786 172.436C199.786 172.436 187.973 174.787 187.285 176.711C186.597 178.635 185.654 182.268 186.869 185.047C188.084 187.826 189.447 202.147 189.447 202.147C189.447 202.147 191.262 206.636 189.995 205.994C188.728 205.353 187.789 200.009 187.377 199.368C186.965 198.727 181.657 188.467 180.04 184.619C178.423 180.772 181.932 177.138 182.807 176.283C183.683 175.428 184.569 174.146 184.569 174.146C184.569 174.146 183.651 167.947 186.497 165.169C189.343 162.39 209.966 158.115 211.692 157.474C213.418 156.833 215.216 153.199 216.733 152.344C218.25 151.489 222.687 153.627 225.336 158.97C227.985 164.314 227.735 165.81 226.854 166.879C225.973 167.948 225.973 167.948 225.973 167.948C225.973 167.948 228.955 168.376 230.139 172.437C231.323 176.498 232.94 180.345 232.862 183.552C232.784 186.758 232.312 192.924 232.296 193.565C232.28 194.206 231.549 193.598 230.96 191.461C230.371 189.324 224.978 173.72 224.165 172.01C223.352 170.3 222.324 168.59 221.912 167.949C221.498 167.307 203.956 167.948 199.786 172.436Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M216.129 235.947C219.418 236.497 224.12 235.534 225.956 233.608C227.792 231.682 233.617 218.471 234.519 215.306C235.421 212.141 235.576 211.453 235.623 209.526C235.67 207.6 235.572 205.948 235.572 205.948L232.669 192.955C232.566 193.114 232.483 193.247 232.421 193.35C232.749 197.363 233.355 205.11 233.226 206.224C233.052 207.738 231.36 209.389 229.702 209.664C228.044 209.939 220.23 208.701 216.783 208.976C213.336 209.251 212.205 210.49 209.557 211.866C206.909 213.242 201.462 216.545 200.076 216.958C198.69 217.371 196.099 216.408 195.031 215.032C193.964 213.656 189.445 202.148 189.445 202.148C189.446 202.887 188.687 204.299 188.687 204.299L191.88 214.482C191.88 214.482 195.425 221.5 197.302 223.564C199.179 225.627 212.84 235.397 216.129 235.947Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M214.502 189.574C214.502 189.574 212.237 192.189 212.63 193.014C213.023 193.84 218.16 208.976 217.982 210.628C217.804 212.279 215.583 213.105 213.807 212.554C212.032 212.004 210.913 207.05 210.913 207.05",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M214.502 189.574C214.502 189.574 212.237 192.189 212.63 193.014C213.023 193.84 218.16 208.976 217.982 210.628C217.804 212.279 215.583 213.105 213.807 212.554C212.032 212.004 210.913 207.05 210.913 207.05",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M216.875 188.197C216.875 188.197 221.775 184.757 226.121 187.096",
    stroke: "#263238",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M204.004 191.225C204.004 191.225 196.476 189.574 193.17 195.353",
    stroke: "#263238",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M203.24 198.254C203.513 199.393 203.164 200.466 202.461 200.65C201.758 200.834 200.968 200.06 200.695 198.921C200.423 197.782 200.771 196.709 201.474 196.525C202.177 196.34 202.967 197.115 203.24 198.254Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M221.32 193.508C221.592 194.647 221.244 195.72 220.541 195.904C219.838 196.088 219.048 195.314 218.775 194.174C218.503 193.035 218.851 191.962 219.554 191.778C220.257 191.594 221.047 192.369 221.32 193.508Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M208.555 219.159C208.555 219.159 218.144 220.948 223.802 214.618",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M296.587 331.959C296.564 332.101 296.53 332.266 296.49 332.442",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M296.315 333.142C288.225 324.186 276.054 330.912 271.086 334.315L268.509 358.019L267.286 362.477C267.286 362.477 258.132 372.284 256.969 374.29C255.806 376.296 253.985 377.856 252.62 378.971C251.256 380.086 248.336 380.977 248.081 382.314C247.826 383.651 252.267 384.32 253.621 383.651C254.975 382.982 258.405 379.416 258.405 379.416L256.258 385.211L273.683 392.789C273.683 392.789 274.699 387.663 275.22 384.542C275.742 381.421 276.589 374.066 276.844 372.729C277.093 371.427 294.584 340.604 296.466 332.543C296.423 332.728 296.374 332.926 296.315 333.142Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M167.111 247.018C167.111 247.018 162.55 251.253 161.556 255.488C160.562 259.723 145.443 312.735 141.905 320.759C138.367 328.783 137.764 335.247 139.695 338.368C141.625 341.489 176.478 366.267 176.478 366.267C176.478 366.267 180.187 378.749 181.226 381.87C182.265 384.991 184.141 390.34 184.141 390.34L198.117 383.876C198.117 383.876 200.721 386.774 202.472 388.111C204.223 389.448 206.435 390.117 206.914 388.78C207.392 387.443 204.81 383.653 204.81 383.653C204.81 383.653 203.537 380.978 203.369 378.749C203.2 376.52 199.954 372.508 198.665 370.502C197.376 368.496 186.633 361.14 186.633 361.14L164.718 326.778L173.327 294.049C173.327 294.049 165.552 256.156 167.111 247.018Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M164.717 326.777L174.638 299.011C174.638 299.011 165.552 256.157 167.112 247.018C167.112 247.018 162.551 251.253 161.557 255.488C160.563 259.723 145.444 312.735 141.906 320.759C138.368 328.783 137.765 335.247 139.696 338.368C140.244 339.253 143.254 343.178 149.205 346.437C151.234 342.556 156.501 333.537 167.946 332.754L164.717 326.777Z",
    fill: "#40B0D5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M148.261 325.216C148.261 325.216 154.969 324.324 161.151 326.776",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M157.225 323.21C157.225 323.21 162.759 324.77 164.717 326.776",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M275.71 361.689C275.71 361.689 263.098 396.96 267.801 415.986C272.504 435.011 276.779 458.098 276.779 458.098H341.55C341.55 458.098 348.818 434.584 347.963 420.475C347.108 406.366 345.398 390.548 345.398 390.548L341.978 349.932H277.42L275.71 361.689Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M306.278 396.533C306.278 396.533 316.966 419.192 321.669 436.935C326.372 454.678 326.158 457.884 326.158 457.884",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M318.249 415.558C318.249 415.558 329.579 405.725 332.999 393.968",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M313.332 254.806L282.977 264.853C282.977 264.853 293.879 282.168 297.513 306.965C301.147 331.762 299.651 356.986 299.651 356.986C299.651 356.986 307.56 361.689 322.524 359.979C337.488 358.269 341.977 349.932 341.977 349.932C341.977 349.932 340.908 308.461 335.35 292.001C329.792 275.541 313.332 254.806 313.332 254.806Z",
    fill: "#3AF2AE",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M268.167 181.155C268.167 181.155 260.845 180.577 257.762 188.863C254.679 197.149 246.008 226.052 247.742 232.411C249.476 238.77 253.33 240.89 254.872 247.826C256.413 254.763 252.945 259.002 252.945 259.002C252.945 259.002 255.643 262.856 262.194 263.049C268.745 263.242 278.573 258.039 285.124 256.497C291.675 254.955 306.127 253.607 315.184 252.258C324.241 250.909 326.167 244.165 326.167 244.165C326.167 244.165 320.001 244.743 319.616 240.889C319.231 237.035 324.241 222.583 322.121 212.563C320.001 202.543 305.549 192.523 299.191 187.513C292.832 182.503 286.859 178.457 280.114 178.264C273.369 178.071 269.323 178.65 268.167 181.155Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M264.891 217.381C264.891 217.381 259.11 227.401 259.881 236.265C260.652 245.129 267.396 245.707 268.745 244.551",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M301.888 202.736C301.888 202.736 315.762 215.646 317.881 229.328",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M281.2 239.491L287.686 257.269C287.686 257.269 301.284 273.094 307.172 270.861C313.06 268.628 307.375 252.792 307.172 250.559C306.969 248.326 305.142 237.362 305.142 237.362C305.142 237.362 301.081 243.859 298.442 243.859C295.803 243.858 281.2 239.491 281.2 239.491Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M276.121 192.764C276.121 192.764 265.517 212.137 265.517 214.788C265.517 217.439 273.674 233.753 275.917 237.016C278.16 240.279 293.658 247.416 297.125 247.62C300.592 247.824 304.058 243.949 304.874 240.89C305.69 237.831 309.148 229.463 308.919 224.806C308.834 223.066 302.549 203.511 300.714 202.492C298.879 201.472 276.121 192.764 276.121 192.764Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M283.056 219.848C283.056 219.848 279.17 218.24 276.892 221.724",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M293.374 216.095C293.374 216.095 294.178 211.941 299.002 213.147",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M280.643 214.353C280.643 214.353 274.479 213.951 272.603 218.239",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M288.952 210.467C288.952 210.467 292.302 205.911 296.992 207.519",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M294.58 224.94C294.58 224.94 292.57 227.888 289.622 227.084",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M300.343 226.816C300.343 226.816 296.457 232.578 285.736 233.382C285.736 233.382 292.838 238.474 296.993 237.134C301.147 235.794 300.343 226.816 300.343 226.816Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M269.387 225.074C269.387 225.074 265.903 223.466 265.367 227.754C264.831 232.042 273.81 233.516 273.81 233.516L269.387 225.074Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M304.07 209.624C304.07 209.624 304.107 207.877 305.814 208.314C307.522 208.751 310.385 213.879 310.084 216.947C309.783 220.014 307.756 220.085 307.756 220.085L304.07 209.624Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M276.922 257.055C276.922 257.055 253.168 272.891 252.153 275.733C251.138 278.575 268.395 362.83 268.395 362.83C268.395 362.83 245.453 414.398 251.138 423.331C256.823 432.264 282.606 440.791 283.825 442.415C285.044 444.039 295.397 399.577 299.864 382.726C304.331 365.875 311.639 335.422 312.045 321.007C312.451 306.592 306.563 287.508 304.533 281.215C302.503 274.921 298.848 263.958 298.848 263.958L276.922 257.055Z",
    fill: "#D9D9D9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M282.949 247.016C282.949 247.016 299.66 263.145 298.848 263.957C298.036 264.769 288.494 278.981 288.494 278.981L273.876 257.664L282.949 247.016Z",
    fill: "#D9D9D9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M310.014 263.145C310.014 263.145 324.632 281.011 330.722 293.801C336.813 306.591 339.655 329.33 339.655 338.263C339.655 347.196 339.655 355.114 339.655 355.114C339.655 355.114 345.949 397.749 347.979 404.855C350.009 411.961 353.258 425.157 353.258 425.157C353.258 425.157 355.694 424.345 355.491 415.412C355.288 406.479 352.04 370.138 349.197 355.723C346.355 341.308 345.174 317.408 343.346 313.145C341.519 308.882 341.519 308.882 341.519 308.882L363.21 302.585C363.21 302.585 349.683 290.336 345.286 271.578C343.286 263.044 338.842 258.477 336.203 256.65C333.564 254.823 314.277 252.793 311.028 252.996C307.781 253.197 310.014 263.145 310.014 263.145Z",
    fill: "#D9D9D9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M310.014 263.145C310.014 263.145 310.623 260.506 311.841 260.912C313.059 261.318 323.413 267.206 324.428 266.597C325.443 265.988 313.871 251.979 311.638 249.949C309.405 247.919 307.172 246.701 307.172 246.701V250.558L310.014 263.145Z",
    fill: "#D9D9D9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M329.708 263.348C329.708 263.348 336.814 286.29 337.626 296.238L329.708 263.348Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M329.708 263.348C329.708 263.348 336.814 286.29 337.626 296.238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M333.759 309.258C333.759 309.258 337.892 292.727 338.884 291.735C339.876 290.743 347.976 287.271 348.638 287.106C349.299 286.941 354.589 290.743 355.416 291.57C356.243 292.397 359.88 294.711 359.218 296.034C358.557 297.357 356.408 296.365 355.25 296.365C354.092 296.365 348.637 299.837 348.307 300.332C347.976 300.828 346.158 304.961 345.497 306.118C344.835 307.274 333.759 309.258 333.759 309.258Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M356.924 292.909C356.924 292.909 354.749 292.039 354.096 292.365C353.444 292.691 345.722 296.28 345.287 296.824C344.852 297.368 344.308 298.238 344.308 298.238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M342.243 295.736C342.243 295.736 343.548 293.996 344.853 293.235C346.158 292.474 350.726 290.734 351.269 290.516C351.813 290.299 353.879 290.516 353.879 290.516",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M350.508 288.559C350.508 288.559 341.808 291.713 341.264 292.474C340.72 293.235 340.72 293.235 340.72 293.235",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M342.092 306.592C342.092 306.592 350.416 300.704 354.07 299.08C357.724 297.456 365.236 300.501 366.657 302.328C368.078 304.155 369.905 312.885 369.702 319.382C369.499 325.879 369.296 328.721 364.83 330.142C360.364 331.563 354.273 332.375 353.664 332.578C353.055 332.781 352.446 320.397 348.588 313.697C344.731 306.998 342.092 306.592 342.092 306.592Z",
    fill: "#D9D9D9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M331.535 310.653C331.535 310.653 333.565 333.798 335.189 336.64C336.813 339.482 340.874 338.873 345.137 337.858C349.4 336.843 355.694 335.422 355.897 334.001C356.1 332.58 355.897 318.977 353.664 313.293C351.431 307.608 347.573 303.548 344.528 304.36C341.483 305.171 331.535 307.201 331.535 310.653Z",
    fill: "#D9D9D9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M312.764 348.768L337.561 327.442L327.146 320.499L307.308 329.261C307.308 329.261 312.598 343.313 312.764 348.768Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M300.696 360.505C300.696 360.505 303.341 360.505 306.978 357.529C310.615 354.553 313.921 352.569 312.929 344.138C311.937 335.707 307.804 322.812 305.821 321.159C303.837 319.506 291.108 321.49 290.777 322.316C290.446 323.142 300.861 338.186 301.688 346.948C302.514 355.711 300.696 360.505 300.696 360.505Z",
    fill: "#D9D9D9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M257.052 276.195C257.052 276.195 255.188 272.626 252.153 275.733C249.117 278.84 247.464 287.602 249.613 298.182C251.762 308.762 257.713 353.066 260.028 358.522C262.342 363.977 264.492 369.102 268.624 369.267C272.757 369.432 286.313 367.614 295.57 363.977C304.828 360.34 304.332 349.429 301.191 340.006C298.05 330.583 292.264 322.813 288.792 320.499C285.32 318.184 283.502 315.209 279.865 308.431C276.228 301.653 267.962 284.46 265.648 281.981",
    fill: "#D9D9D9"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M257.052 276.195C257.052 276.195 255.188 272.626 252.153 275.733C249.117 278.84 247.464 287.602 249.613 298.182C251.762 308.762 257.713 353.066 260.028 358.522C262.342 363.977 264.492 369.102 268.624 369.267C272.757 369.432 286.313 367.614 295.57 363.977C304.828 360.34 304.332 349.429 301.191 340.006C298.05 330.583 292.264 322.813 288.792 320.499C285.32 318.184 283.502 315.209 279.865 308.431C276.228 301.653 267.962 284.46 265.648 281.981",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M273.2 337.941C272.369 338.702 271.507 339.389 270.625 339.966",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M283.385 323.677C283.385 323.677 280.057 330.492 275.338 335.767",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M336.073 313.225C336.073 313.225 311.772 315.539 305.49 315.374C299.208 315.209 290.281 311.902 290.281 311.902C290.281 311.902 279.535 307.438 277.221 306.281C274.907 305.124 269.451 305.124 267.963 305.785C266.475 306.446 263.169 309.091 263.665 310.745C264.161 312.398 266.145 311.241 267.137 310.414C268.129 309.588 269.782 308.926 269.782 308.926L275.072 310.083L276.064 311.406C276.064 311.406 268.79 312.729 267.798 313.225C266.806 313.721 263.996 320.003 263.5 321.325C263.004 322.647 263.5 322.482 264.492 322.482C265.484 322.482 265.484 322.482 265.484 322.482C265.484 322.482 264.988 325.127 265.98 325.458C266.972 325.789 268.294 325.127 268.294 325.127C268.294 325.127 269.451 326.284 269.947 326.284C270.443 326.284 275.568 323.474 276.394 322.978C277.221 322.482 284.329 323.97 286.148 323.97C287.967 323.97 294.91 323.805 294.91 323.805C294.91 323.805 328.304 333.393 332.767 334.055C337.231 334.716 340.206 334.551 341.859 329.591C343.512 324.632 339.875 313.887 336.073 313.225Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M268.294 325.128C268.294 325.128 272.758 320.168 273.915 319.507C275.072 318.846 277.387 318.019 277.387 318.019",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M265.483 322.483L270.112 317.027L275.072 315.044",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M147.148 180.058C147.148 180.058 148.505 180.872 150.677 181.687C152.849 182.501 158.279 184.402 160.722 187.117C163.165 189.832 162.351 196.348 162.351 196.348",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M116.153 202.644L114.026 207.207",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0071 188.313C99.0071 188.313 97.526 195.307 96.03 196.91C94.534 198.513 92.157 200.407 92.946 203.904C93.735 207.401 98.3451 209.587 98.3311 210.17C98.3171 210.753 89.973 212.356 90.2 214.978C90.428 217.601 92.6811 220.806 92.6811 220.806C92.6811 220.806 86.512 222.846 85.99 226.343C85.468 229.84 87.5691 233.337 87.5371 234.648C87.5051 235.959 83.7921 238.874 84.9011 241.205C86.0101 243.536 88.6401 243.245 88.7751 243.682C88.9101 244.119 87.2611 246.013 87.2331 247.179C87.2051 248.345 88.0541 249.365 88.0541 249.365H137.304L123.335 176.51L104.802 183.65L99.0071 188.313Z",
    fill: "#5CFFE9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M165.726 353.646C165.726 353.646 175.884 376.764 177.217 382.438C178.551 388.112 179.183 413.372 177.068 423.21C173.217 441.124 162.181 458.097 162.181 458.097H106.237L94.7012 404.231L111.549 351.754L165.726 353.646Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M156.448 398.201L151.739 410.391L153.982 457.837",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M164.837 338.304C164.837 338.304 174.721 346.711 175.905 349.863C177.09 353.015 177.846 373.822 178.389 377.395C178.933 380.968 176.539 384.33 176.539 384.33L168.017 363.103C168.017 363.103 167.196 353.646 167.001 353.015C166.806 352.385 165.247 347.341 165.247 347.341L164.837 338.304Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M172.984 357.639C172.984 357.639 173.102 361.422 173.456 364.154C173.81 366.886 174.949 371.93 172.606 373.191",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M172.984 357.639C172.984 357.639 173.102 361.422 173.456 364.154C173.81 366.886 174.949 371.93 172.606 373.191",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M128.969 248.774L142.409 249.194L152.017 249.51L163.191 258.862C163.191 258.862 172.567 305.518 173.336 308.461C174.105 311.403 165.373 333.471 164.692 335.572C164.01 337.674 165.725 353.646 165.725 353.646C165.725 353.646 161.425 357.639 147.508 359.531C133.591 361.423 117.551 355.538 117.551 355.538C117.551 355.538 128.102 327.796 130.355 312.875C130.355 312.875 132.315 284.082 131.673 275.886C131.032 267.689 128.969 248.774 128.969 248.774Z",
    fill: "#5CFFE9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M162.496 317.832L140.738 328.869",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M161.235 321.616L151.144 326.661",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M125.287 233.324C125.287 233.324 133.371 261.312 134.417 266.267C135.463 271.221 145.812 277.05 152.155 273.844C158.498 270.638 156.461 264.519 155.387 260.73C154.313 256.942 152.017 249.51 152.017 249.51L154.463 226.779C154.463 226.779 146.784 236.979 143.987 238.144C141.191 239.311 125.287 233.324 125.287 233.324Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M140.412 240.688L151.005 250.91L153.607 228.98L140.412 240.688Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M151.377 249.795L150.82 259.83",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M152.09 247.199C152.09 247.199 167.06 289.966 168.717 299.634C170.374 309.302 170.743 311.403 170.872 314.766C171 318.129 168.3 325.484 168.3 325.484C168.3 325.484 178.914 312.454 178.979 301.105C179.044 289.756 171.335 255.475 167.737 253.398C153.435 245.139 152.09 247.199 152.09 247.199Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M165.987 268.307C165.987 268.307 172.558 287.482 171.505 301.869",
    stroke: "#D9D9D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M115.193 199.824L121.983 190.207L153.41 222.117C153.41 222.117 151.5 240.768 151.486 241.351C151.472 241.934 153.434 245.139 153.434 245.139C153.434 245.139 154.29 245.868 154.994 246.888C155.698 247.908 154.969 247.908 154.788 249.365C154.607 250.822 155.609 251.551 156.32 252.279C157.031 253.008 158.762 253.736 159.767 254.319C160.773 254.902 159.867 256.213 159.106 257.525C158.346 258.836 157.266 261.313 158.513 263.936C159.761 266.559 160.5 266.122 162.636 268.161C164.772 270.201 161.666 272.095 161.666 272.095C161.666 272.095 163.279 271.658 164.601 271.221C165.923 270.784 166.541 269.327 165.983 268.307C165.425 267.287 164.34 263.936 164.792 263.353C165.243 262.77 169.373 260.73 170.577 259.127C171.782 257.524 170.477 257.233 171.511 256.65C172.545 256.067 174.617 254.756 175.103 252.716C175.59 250.676 173.173 248.199 173.919 247.471C174.665 246.742 177.467 242.256 177.499 240.945C177.531 239.634 175.87 237.416 175.87 237.416C175.87 237.416 176.953 236.544 177.638 232.318C178.323 228.092 175.004 226.781 174.769 224.45C174.534 222.119 177.963 218.913 178.016 210.753C178.068 202.593 164.577 200.116 164.165 199.096C163.753 198.076 164.229 196.473 163.99 194.288C163.752 192.102 158.452 188.314 158.452 188.314C158.452 188.314 159.088 186.128 159.56 184.671C160.033 183.214 159.336 181.903 156.77 179.571C154.204 177.24 141.792 166.311 136.575 165.146C131.358 163.98 122.623 169.663 121.589 170.246C120.555 170.829 112.299 168.789 109.772 170.829C107.245 172.869 106.432 176.366 105.814 177.823C105.196 179.28 103.01 179.28 101.663 180.737C100.316 182.194 98.114 194.871 98.114 194.871",
    fill: "#5CFFE9"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M115.193 199.824L121.983 190.207L153.41 222.117C153.41 222.117 151.5 240.768 151.486 241.351C151.472 241.934 153.434 245.139 153.434 245.139C153.434 245.139 154.29 245.868 154.994 246.888C155.698 247.908 154.969 247.908 154.788 249.365C154.607 250.822 155.609 251.551 156.32 252.279C157.031 253.008 158.762 253.736 159.767 254.319C160.773 254.902 159.867 256.213 159.106 257.525C158.346 258.836 157.266 261.313 158.513 263.936C159.761 266.559 160.5 266.122 162.636 268.161C164.772 270.201 161.666 272.095 161.666 272.095C161.666 272.095 163.279 271.658 164.601 271.221C165.923 270.784 166.541 269.327 165.983 268.307C165.425 267.287 164.34 263.936 164.792 263.353C165.243 262.77 169.373 260.73 170.577 259.127C171.782 257.524 170.477 257.233 171.511 256.65C172.545 256.067 174.617 254.756 175.103 252.716C175.59 250.676 173.173 248.199 173.919 247.471C174.665 246.742 177.467 242.256 177.499 240.945C177.531 239.634 175.87 237.416 175.87 237.416C175.87 237.416 176.953 236.544 177.638 232.318C178.323 228.092 175.004 226.781 174.769 224.45C174.534 222.119 177.963 218.913 178.016 210.753C178.068 202.593 164.577 200.116 164.165 199.096C163.753 198.076 164.229 196.473 163.99 194.288C163.752 192.102 158.452 188.314 158.452 188.314C158.452 188.314 159.088 186.128 159.56 184.671C160.033 183.214 159.336 181.903 156.77 179.571C154.204 177.24 141.792 166.311 136.575 165.146C131.358 163.98 122.623 169.663 121.589 170.246C120.555 170.829 112.299 168.789 109.772 170.829C107.245 172.869 106.432 176.366 105.814 177.823C105.196 179.28 103.01 179.28 101.663 180.737C100.316 182.194 98.114 194.871 98.114 194.871",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M128.125 244.046C128.125 244.046 143.338 297.533 144.011 304.468C144.683 311.403 120.884 356.799 116.031 366.256C111.178 375.713 100.601 404.506 98.8912 414.384C97.1802 424.262 95.8442 436.031 95.8442 436.031C95.8442 436.031 83.1722 429.936 74.8932 424.682C66.6142 419.428 65.2142 416.486 65.8702 415.435C66.5262 414.384 69.9952 401.354 69.9952 401.354C69.9952 401.354 62.8332 393.368 63.2742 392.527C63.7152 391.686 79.9932 335.783 79.9932 335.783C79.9932 335.783 84.2772 245.833 85.9582 245.833C87.6382 245.832 128.125 244.046 128.125 244.046Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M126.59 269.586L144.011 304.468",
    stroke: "#D9D9D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0301 246.462C96.0301 246.462 83.4811 243.94 81.2981 247.303C79.1151 250.666 59.8691 307.62 58.6911 312.874C57.5131 318.128 93.5581 357.008 93.5581 357.008L112.143 344.608L90.1951 313.714L102.194 269.58",
    fill: "#263238"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0301 246.462C96.0301 246.462 83.4811 243.94 81.2981 247.303C79.1151 250.666 59.8691 307.62 58.6911 312.874C57.5131 318.128 93.5581 357.008 93.5581 357.008L112.143 344.608L90.1951 313.714L102.194 269.58",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M99.042 283.297L90.083 310.989L110.128 341.036",
    stroke: "#D9D9D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M101.486 274.609L100.202 278.705",
    stroke: "#D9D9D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M110.128 341.036L89.9641 357.849L96.7011 366.046L117.905 349.653L110.128 341.036Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M116.413 350.494C116.413 350.494 133.198 368.988 135.069 369.829C136.94 370.67 140.626 374.663 141.631 376.554C142.636 378.445 144.046 380.967 145.492 382.018C146.938 383.069 147.117 384.33 144.58 384.96C142.043 385.59 139.726 385.801 138.326 382.858C136.926 379.915 134.681 377.184 134.681 377.184L120.34 387.902C120.34 387.902 117.253 376.553 116.889 374.241C116.525 371.929 115.776 368.146 115.776 368.146L106.123 358.899L116.413 350.494Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M92.896 231.151C92.896 231.151 91.504 240.474 92.301 243.682C93.144 247.077 99.975 246.468 98.574 250.976C98.123 252.429 96.357 253.979 96.91 255.628C97.476 257.317 99.699 257.413 100.933 258.372C103.202 260.135 102.39 262.026 103.161 264.52C103.719 266.324 105.638 266.947 106.158 268.377C106.774 270.071 105.592 271.129 107.472 272.97C110.746 276.176 113.208 276.759 113.653 276.467C114.097 276.176 113.241 275.447 115.305 274.427C117.37 273.407 121.35 271.513 120.66 269.91C119.981 268.332 119.302 266.755 119.286 266.716C120.247 268.929 123.231 266.695 124.047 265.529C125.908 262.87 123.061 260.008 123.394 257.134C123.763 253.951 127.348 252.31 127.749 249.102C128.142 245.96 124.879 243.796 125.589 240.913C125.912 239.602 126.093 238.145 126.093 238.145C126.093 238.145 125.144 235.231 123.711 234.211C122.279 233.191 121.795 229.111 121.684 227.654",
    fill: "#5CFFE9"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M92.896 231.151C92.896 231.151 91.504 240.474 92.301 243.682C93.144 247.077 99.975 246.468 98.574 250.976C98.123 252.429 96.357 253.979 96.91 255.628C97.476 257.317 99.699 257.413 100.933 258.372C103.202 260.135 102.39 262.026 103.161 264.52C103.719 266.324 105.638 266.947 106.158 268.377C106.774 270.071 105.592 271.129 107.472 272.97C110.746 276.176 113.208 276.759 113.653 276.467C114.097 276.176 113.241 275.447 115.305 274.427C117.37 273.407 121.35 271.513 120.66 269.91C119.981 268.332 119.302 266.755 119.286 266.716C120.247 268.929 123.231 266.695 124.047 265.529C125.908 262.87 123.061 260.008 123.394 257.134C123.763 253.951 127.348 252.31 127.749 249.102C128.142 245.96 124.879 243.796 125.589 240.913C125.912 239.602 126.093 238.145 126.093 238.145C126.093 238.145 125.144 235.231 123.711 234.211C122.279 233.191 121.795 229.111 121.684 227.654",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M119.108 184.951C119.108 184.951 107.328 202.079 108.229 205.703C109.129 209.326 118.118 232.549 121.192 234.854C124.265 237.16 136.65 242.595 140.764 242.759C144.877 242.924 147.882 241.277 149.597 238.477C151.312 235.677 157.846 224.313 157.906 221.843C157.966 219.372 152.693 195.663 151.713 195.334C150.731 195.004 119.108 184.951 119.108 184.951Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M137.109 203.148C137.109 203.148 136.77 207.719 137.191 209.205C137.612 210.691 141.482 216.062 141.574 216.976C141.666 217.89 140.158 218.805 138.082 219.605",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M110.527 212.784C110.527 212.784 107.948 210.478 106.562 213.278C105.177 216.078 106.237 219.866 110.608 222.995C114.979 226.124 115.967 226.124 115.967 226.124L110.527 212.784Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M153.628 201.255C153.628 201.255 155.962 200.102 157.043 203.067C158.124 206.031 156.458 213.608 156.458 213.608L153.628 201.255Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M131.291 225.593C131.291 225.593 138.899 225.018 140.762 224.097C142.625 223.177 145.877 219.425 145.877 219.425C145.877 219.425 145.869 227.668 141.853 229.081C139.031 230.073 131.291 225.593 131.291 225.593Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M118.83 207.605C118.83 207.605 119.393 203.262 126.955 202.462L118.83 207.605Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M118.83 207.605C118.83 207.605 119.393 203.262 126.955 202.462",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M136.997 199.411C136.997 199.411 141.641 195.376 146.664 200.291L136.997 199.411Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M136.997 199.411C136.997 199.411 141.641 195.376 146.664 200.291",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M128.213 209.813C128.611 211.154 128.183 212.48 127.256 212.775C126.329 213.07 125.255 212.223 124.857 210.882C124.459 209.541 124.887 208.215 125.814 207.919C126.74 207.625 127.814 208.472 128.213 209.813Z",
    fill: "#263238"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M143.76 205.506C144.158 206.847 143.73 208.173 142.803 208.468C141.876 208.763 140.803 207.916 140.404 206.575C140.006 205.234 140.434 203.908 141.361 203.613C142.288 203.318 143.362 204.165 143.76 205.506Z",
    fill: "#263238"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M464.791 458.098H17.0259",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M488.566 458.098H471.924",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step-1.46d1c8100e2997aa1b2dad47767cf671.svg";
export { ForwardRef as ReactComponent };